















































































import Vue from "vue";
import { router, IconRouteConfig, pages } from "./router";
import { Route } from "vue-router";

export interface MenuItem {
  id: string;
  path?: string;
  fullPath?: string;
  menu?: string;
  name?: string;
  icon?: string | null;
  children?: MenuItem[];
}

function generateMenu(items: IconRouteConfig[] | undefined, result: MenuItem[] = []): MenuItem[] {
  if (!items) return result;
  for (const item of items) {
    if (item.hideInMenu) continue;
    const currentNode: MenuItem = {
      id: item.fullPath ? item.fullPath : item.path,
      menu: item.menu,
      name: item.name,
      path: item.path,
      fullPath: item.fullPath,
      icon: item.icon,
      children: [],
    };
    result.push(currentNode);
    if (item.children) {
      currentNode.children = generateMenu(item.children);
    }
  }
  return result;
}

export interface Data {
  drawer: boolean | null;
  menu: MenuItem[];
  opened: string[];
  active: string[];
  promo: boolean;
  currentPath: string;
}

export default Vue.extend({
  name: "App",

  methods: {
    onMenuClick(item: MenuItem) {
      if (item.fullPath && item.fullPath !== router.currentRoute.fullPath) {
        router.push(item.fullPath);
        this.updateCurrentPath();
      }
    },
    checkOpened(route: Route) {
      const paths = Object.keys(pages) as string[];
      const opened: string[] = paths.filter((path) => route.fullPath.startsWith(path)).concat(this.opened);
      const set = new Set(opened);
      this.opened = Array.from(set);
      this.active = paths.filter((path) => path === (route.fullPath.length ? route.fullPath : "/")).map((path) => path);
    },
    updateCurrentPath() {
      this.currentPath = router.currentRoute.fullPath;
    },
    goTo(path: string) {
      router.push(path);
      this.updateCurrentPath();
    },
  },

  created() {
    router.afterEach(this.checkOpened);
    this.checkOpened(router.currentRoute);
  },

  data: function(): Data {
    return {
      drawer: null,
      menu: generateMenu(router.options.routes),
      opened: [],
      active: [],
      promo: false,
      currentPath: router.currentRoute.fullPath,
    };
  },
});
